import { Component } from '@angular/core';

@Component({
    selector: 'app-footer-cmp',
    templateUrl: 'footer.component.html',
    styleUrls: ['./footer.scss'],
    standalone: false
})

export class FooterComponent {
    currentDate = new Date();
    test: Date = new Date();
}
